const typeformForms: Record<string, string> = {
  NmrJbFQH: "Eligibility Questionnaire",
  Q48WHDmc: "Medical Questionnaire"
};

export default typeformForms;
